import { MoveUp, MoveDown } from "lucide-react";
import { headerConfig } from "./header-config";
import { useDispatch, useSelector } from "@/core/redux/store";
import { RootState } from "@/core/redux/store";
import { setSort } from "@/core/redux/slices/supplier-responses-all";
import { SupplierResponsesSortBy } from "@/shared/services/interface/requests/ISupplierResponsesAllRequest";
import useGridTemplate from "../utils/useGridTemplate";

// Map UI field names to API field names
const fieldToSortByMap: Record<string, SupplierResponsesSortBy> = {
  answered: "respondedCount",
  notAnswered: "notRespondedCount",
  status: "status",
};

export default function TableHeader() {
  const dispatch = useDispatch();
  const { sort, hiddenColumnFields } = useSelector(
    (state: RootState) => state.supplierResponsesAll
  );

  const isColumnVisible = (field: string) => {
    return !hiddenColumnFields.includes(field);
  };

  const handleSort = (field: string) => {
    const apiField = fieldToSortByMap[field];
    if (!apiField) return; // Only sortable fields

    if (sort.sortBy === apiField) {
      // Aynı column'a tıklandı: ASC → DESC → null → ASC
      if (sort.sortOrder === "ASC") {
        dispatch(setSort({ sortBy: apiField, sortOrder: "DESC" }));
      } else if (sort.sortOrder === "DESC") {
        dispatch(setSort({ sortBy: null, sortOrder: null }));
      } else {
        dispatch(setSort({ sortBy: apiField, sortOrder: "ASC" }));
      }
    } else {
      // Farklı column'a tıklandı: yeni column ASC olur
      dispatch(setSort({ sortBy: apiField, sortOrder: "ASC" }));
    }
  };

  const getInnerClassName = (field: string, sortable: boolean) => {
    const apiField = fieldToSortByMap[field];
    const isActive =
      apiField && sort.sortBy === apiField && sort.sortOrder !== null;
    const baseClasses =
      "flex select-none items-center ml-[-8px] py-[8px] px-[8px] overflow-clip rounded-md shrink-0";

    const bgClasses = sortable
      ? isActive
        ? "bg-accent"
        : "bg-white hover:bg-accent"
      : "";
    const cursorClass = sortable ? "cursor-pointer" : "";

    return `${baseClasses} ${bgClasses} ${cursorClass}`;
  };

  return (
    <div
      className="grid w-full items-start border-b border-border"
      style={{
        gridTemplateColumns: useGridTemplate(),
      }}
    >
      {headerConfig
        .filter((config) => isColumnVisible(config.field))
        .map((config) => {
          const apiField = fieldToSortByMap[config.field];
          const isActive =
            apiField && sort.sortBy === apiField && sort.sortOrder !== null;
          const showArrow = isActive && config.sortable;

          return (
            <div key={config.field} className={config.parentClassName}>
              <div
                className={getInnerClassName(config.field, config.sortable)}
                onClick={() => config.sortable && handleSort(config.field)}
              >
                <div className="text-[12px] font-600 text-muted-foreground flex items-center gap-1">
                  {config.label}
                  {showArrow && (
                    <>
                      {sort.sortOrder === "ASC" ? (
                        <MoveUp className="w-3 h-3" />
                      ) : (
                        <MoveDown className="w-3 h-3" />
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      <div className="flex items-center h-12 justify-center p-1 relative"></div>
    </div>
  );
}
